import React, { useEffect } from 'react';

const Datawrapper = ({
    id,
    src,
    title,
    ariaLabel
}) => {

    useEffect(() => {
        window.addEventListener("message", (function(a) {
            if (void 0!==a.data["datawrapper-height"]) {
                var e=document.querySelectorAll("iframe");
                for(var t in a.data["datawrapper-height"]) {
                    for(var r=0;r<e.length;r++) {
                        if(e[r].contentWindow===a.source) {
                            var i=a.data["datawrapper-height"][t]+2+"px";
                            e[r].style.height=i
                        }
                    }
                }
            }
        }))
    }, []);   

    return (
        <div className="data-wrapper-container">
            <iframe
                id={id}
                src={src}
                title={title}
                aria-label={ariaLabel}
                height="345"
                data-external="1"
            />
        </div>        
    );

}

export default Datawrapper;
